import { Map as ImmutableMap } from 'immutable'
import { createSelector } from 'reselect'

const getEssentialsState = (state: Map<string, any> | ImmutableMap<string, any>) => state?.get('essentials')

export const getRegisteredEventsForUser = createSelector(getEssentialsState, (state) => {
  return state?.get('registeredEventsForUser')
})

export const getEssentialsEventsFullList = createSelector(getEssentialsState, (state) => {
  return state?.get('essentialsEventsFullList')
})

export const getShouldGoFullscreenForMixes = createSelector(getEssentialsState, (state) => {
  return state?.get('shouldGoFullscreenForMixes')
})

export const getShuffledUpcomingResourceGridEvents = createSelector(getEssentialsState, (state) => {
  return state?.get('shuffledUpcomingResourceGridEvents')
})

export const getEssentialsEventsByTags = createSelector(getEssentialsState, (state) => {
  return state?.get('essentialsEventsByTags')
})

// Loading state selectors
export const getRegisteredEventsForUserLoading = createSelector(getEssentialsState, (state) => {
  return state?.get('registeredEventsForUserLoading')
})

export const getEssentialsEventsFullListLoading = createSelector(getEssentialsState, (state) => {
  return state?.get('essentialsEventsFullListLoading')
})

export const getEssentialsEventsByTagsLoading = createSelector(getEssentialsState, (state) => {
  return state?.get('essentialsEventsByTagsLoading')
})
